<script lang="ts">
  import type { SustainabilityBadge } from "../../../../types/CinemaProductsDto.types.ts";

  type SustainabilityBadgesProps = {
    badges: SustainabilityBadge[] | undefined;
  };

  let { badges }: SustainabilityBadgesProps = $props();
</script>

{#if badges?.length}
  <div class="sustainabilityBadges">
    {#each badges as badge (badge.value)}
      <ofc-sustainability-badge-v1
        as-button
        icon={badge.iconClass}
        data-oc-sheet-v1-create
        data-oc-sheet-v1-create.headline="Was bedeutet dieses Zeichen?"
        data-oc-sheet-v1-create.base64-url={btoa(badge.explanatoryTextUrl)}
      ></ofc-sustainability-badge-v1>
    {/each}
  </div>
{/if}

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .sustainabilityBadges {
    display: flex;
    gap: tokens.$oc-semantic-spacing-25;
    flex-wrap: wrap;
    margin-top: tokens.$oc-semantic-spacing-50;
  }
</style>
